import request from './request.js';
import {requestbody} from './request.js'

export async function reporttrackquery(params = {

}) {
    return await requestbody('/report/track/query', 'post', params)
}

export async function reporttrackdesc(params = {

}) {
    return await requestbody('/report/track/desc', 'post', params)
}

export async function reportquerytrack(params = {

}) {
    return await requestbody('/report/query/report/track', 'post', params)
}